import React from 'react';
import EanCheck from './EanCheck';
import {useEanCheckBlockQuery} from "@apps/Shared/GraphQL/generated";
import {EanCheckProps} from "@sharedComponents/EanCheck/types";
import {getLocale} from "@apps/Shared/Utils/Utils";

function App(): JSX.Element {
    const hiddenInput = document.querySelector('.js-ean-check');
    const id = Number((hiddenInput as HTMLInputElement).value);
    const locale = getLocale();

    const {data} = useEanCheckBlockQuery({
        id: id,
        locale: [locale]
    });

    if (data && data.Content && data.Content.items && data.Content.items.length > 0) {
        const item: any = data.Content.items[0];
        const props: EanCheckProps = {
            heading: item.Heading,
            image: {
                type: "image",
                path: item.Image.Expanded.RelativePath,
                altText: item.Image.Expanded.AltText,
                name: item.Image.Name
            }
        }

        return (
            <EanCheck {...props} />
        )
    } else {
        return <></>
    }
}

export default App;